import React from 'react';
import HtmlContent from '../../../../components-legacy/HtmlContent';
import useContext from '../../../../hooks/useContext';
import { Columns, Column } from '../../../../styled/Columns/wrappers';
import Distance from '../../../../styled/Distance';
import { H4 } from '../../../../styled/Heading';
import { ProductContext } from '../providers/ProductProvider';

const ArticleInformation = () => {
  const { goodToKnow, longDescription, m3Id, moderArtikelId, variantId } =
    useContext(ProductContext);

  return (
    <>
      <HtmlContent markdown={longDescription} />

      {!!goodToKnow && (
        <>
          <Distance size="3" className="hidden-md" />
          <Distance size="4" className="hidden-lt-md" />
          <H4>Bra att veta</H4>
          <HtmlContent markdown={goodToKnow} />
        </>
      )}

      <Distance line size="3" className="hidden-md" />
      <Distance line size="4" className="hidden-lt-md" />

      {!moderArtikelId && m3Id && (
        <Columns>
          <Column>
            <strong>Artikelnummer:</strong>
          </Column>
          <Column className="text-right">
            <span className="bump-left">{m3Id}</span>
          </Column>
        </Columns>
      )}

      {moderArtikelId && !m3Id && (
        <Columns>
          <Column>
            <strong>Moderartikel:</strong>
          </Column>
          <Column className="text-right">
            <span className="bump-left">{moderArtikelId}</span>
          </Column>
        </Columns>
      )}

      {moderArtikelId && m3Id && moderArtikelId === m3Id && (
        <Columns>
          <Column>
            <strong>Moderartikel:</strong>
          </Column>
          <Column className="text-right">
            <span className="bump-left">{moderArtikelId}</span>
          </Column>
        </Columns>
      )}

      {moderArtikelId && m3Id && moderArtikelId !== m3Id && (
        <>
          <Columns>
            <Column>
              <strong>Artikelnummer:</strong>
            </Column>
            <Column className="text-right">
              <span className="bump-left">{m3Id}</span>
            </Column>
          </Columns>
          <Columns>
            <Column>
              <strong>Moderartikel:</strong>
            </Column>
            <Column className="text-right">
              <span className="bump-left">{moderArtikelId}</span>
            </Column>
          </Columns>
        </>
      )}
      {variantId && (
        <Columns>
          <Column>
            <strong>Variant:</strong>
          </Column>
          <Column className="text-right">
            <span className="bump-left">{variantId}</span>
          </Column>
        </Columns>
      )}
    </>
  );
};

export default ArticleInformation;
